export default "__VITE_ASSET__C_92AyWR__"